import React from 'react';
import { Sidebar } from '../components/application/Sidebar';
import { TopBar } from '../components/application/TopBar';
import { ContentFeed } from '../components/application/ContentFeed';
export const Application = () => {
  return <div className="w-full min-h-screen bg-[#1A1A1D] flex overflow-hidden" data-id="element-524">
      <Sidebar data-id="element-525" />
      <div className="flex-1 flex flex-col h-screen overflow-hidden" data-id="element-526">
        <TopBar data-id="element-527" />
        <div className="flex-1 overflow-y-auto bg-[#1A1A1D]" data-id="element-528">
          <div className="max-w-7xl mx-auto" data-id="element-529">
            <ContentFeed data-id="element-530" />
          </div>
        </div>
      </div>
    </div>;
};